module.exports = __webpack_public_path__ + "df6ac600491caafd82ba4ca852316a99.gltf";